class OnlineAccountController
  firstLoad = true
  @updateAutoReload: (url) ->
    if $("#auto-reload-toogle-button").attr('data-show-alert') == 'true'
      $("#auto-reload-toogle-button").prop("checked", false)
      buttonEnable = $("#dialog-auto-reload").data("button-enable")
      buttonCancel = $("#dialog-auto-reload").data("button-cancel")
      returnButtonAfterClose = true
      $("#dialog-auto-reload").dialog({
        modal: true,
        buttons: [{
          text: buttonEnable
          click: ->
            returnButtonAfterClose = false
            $(this).dialog("close")
            $("#auto-reload-toogle-button").prop("checked", true)
            OnlineAccountController.callAjax(url)
        }, {
          text: buttonCancel
          click: ->
            $(this).dialog("close")
        }]
      });
      $("#dialog-auto-reload").dialog("open");
    else
      @callAjax(url)

  @callAjax: (url) ->
    $.ajax({
      url: url,
      type: 'POST',
      data: {enable: $("#auto-reload-toogle-button").prop("checked")},
      dataType: 'json',
      success: (data, textStatus, jqXHR) ->
        if data['error']
          alert(data['error'])
        else
          OnlineAccountController.setAutoReloadButton(data)
      error: (jqXHR, textStatus, errorThrown) ->
        console.log(textStatus)
        $("#auto-reload-toogle-button").attr("disabled", false)
    })

  @setAutoReloadButton: (data) ->
    $("#auto-reload-toogle-button").prop("checked", data['auto_reload_value']);
    $("#auto-reload-toogle-button").attr('data-show-alert', data['show_alert'])
    $label = $("#auto-reload-on-value")
    if data['auto_reload_value']
      $label.removeClass("recharge-off").addClass("recharge-on")
      $label.text($label.data("text-on"))
    else if not firstLoad
      $label.removeClass("recharge-on").addClass("recharge-off")
      $label.text($label.data("text-off"))
    firstLoad = false

    $(document).on('change', '#auto-reload-toogle-button', (event) ->
      OnlineAccountController.updateAutoReload($(this).data('url'))
      $("#auto-reload-toogle-button").attr("disabled", true)
      setTimeout ->
        $("#auto-reload-toogle-button").attr("disabled", false)
      , 2000
    )

module.exports = OnlineAccountController
